module.exports = __webpack_public_path__ + "img/03—01—01—Individual—WLAN 2.4 GHz.b3fb9b58.jpg";